import Label from '../../../ui/Label'
import Input from '../../../ui/Input'
import { CreateClientRequest } from '../../../../types/client';

interface ClientModalInputWrapProps {
    label: string;
    value: string;
    handleChange: (field: keyof CreateClientRequest, value: string) => void;
    typeOfAction: 'newClient' | 'update'
    type: string;
    placeholder?: string;
    field: keyof CreateClientRequest;
    isUpdateSchedule?: boolean;
}

export default function ClientModalDateInputWrap({ label, value, handleChange, typeOfAction, type, placeholder, field, isUpdateSchedule }: ClientModalInputWrapProps) {
    return (
        <div>
            <Label label={label}/>
            <div className='grid grid-cols-1 w-full space-y-1'>
                <div className='w-full'>
                    <Input
                        type={type}
                        value={value}
                        onChange={(e) => {
                            handleChange(field, e.target.value)
                        }}
                        placeholder={placeholder}
                        required
                        disabled={typeOfAction === 'update' && !isUpdateSchedule}
                    />
                </div>
            </div>
        </div>
    )
}
